import gql from 'graphql-tag';
export default gql`
  query dbquoteStatuses($orgId: String) {
    dbQuoteStatuses(orgId: $orgId) {
      id
      name
      description
      code
    }
  }
`;
